import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  previewImage?: string;
  badge?: string;
}
export function AccordionItem({
  title,
  children,
  isOpen: defaultOpen = false,
  previewImage,
  badge
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className={`mb-4 bg-white rounded-2xl overflow-hidden transition-all ${isOpen ? 'shadow-lg border-2 border-teal-600' : 'shadow-sm border-2 border-emerald-100 hover:border-teal-300'}`} data-id="element-115" data-mp="2n24g7zv31bkl">
      {previewImage && <div className="relative h-36 w-full overflow-hidden" data-id="element-116" data-mp="2s43jl9qto8hj">
          <img src={previewImage} alt="" aria-hidden="true" className="w-full h-full object-cover object-top" data-id="element-117" data-mp="11qcorvzi81to" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/10 to-white" data-id="element-118" data-mp="xr3xqyvumi1t" />
        </div>}
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 py-5 flex items-center justify-between bg-white hover:bg-emerald-50/40 transition-colors text-left gap-3" data-id="element-119" data-mp="3l36tjnn0dkr9">
        <span className="flex items-center gap-4 pr-2" data-id="element-120" data-mp="3usqauov2p6k0">
          {badge && <span className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-black text-sm transition-colors ${isOpen ? 'bg-teal-700 text-white' : 'bg-emerald-100 text-teal-700'}`} aria-hidden="true" data-id="element-121" data-mp="3uutbs3xrkk3i">
              {badge}
            </span>}
          <span className="font-semibold text-gray-800" data-id="element-122" data-mp="hkdsubfbwqei">{title}</span>
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-teal-600" data-id="element-123" data-mp="2egb9delnxjzw">
          <ChevronDown size={20} data-id="element-124" data-mp="2bf84rl4nakfz" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-125" data-mp="27cv95pjm42wx">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-126" data-mp="2lb1lzhtb7243">
            <div className="px-6 pb-5 text-gray-600 text-sm leading-relaxed border-t border-emerald-50 pt-4" data-id="element-127" data-mp="342cbpvnat8ue">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}